import { Dati2, Gender, MaritalStatus, Province } from '@xendit/id-open-banking-ekyb-common/dist/enums/submission';
import {
  BeneficialOwnerAddressAnswer,
  BeneficialOwnerIncomeSourceMap,
  beneficialOwnerDifferentAddress,
  GenderMap,
  MaritalStatusMap,
  ProvinceMap,
  Dati2Map
} from 'helpers/utils/enumsNameMappings';
import { FormBuilderField } from 'types/form.type';
import { t } from 'i18next';
import { BeneficialOwnerIncomeSourceType } from 'types/override.type';

export const Form2Section3Fields = (): FormBuilderField[] => [
  {
    name: 'entity.beneficial_owner.name',
    label: 'Nama Lengkap (menurut dokumen identitas)',
    type: 'text',
    placeholder: 'Nama',
    fullWidth: true,
    validation: {
      required: 'Nama harus diisi'
    }
  },
  {
    name: `entity.beneficial_owner.gender`,
    label: 'Jenis Kelamin',
    type: 'radio',
    fullWidth: true,
    options: Object.keys(Gender).map((item) => {
      return { label: GenderMap[item as Gender], value: item, key: item };
    }),
    validation: {
      required: 'Jenis Kelamin harus diisi'
    }
  },
  {
    name: `entity.beneficial_owner.marital_status`,
    label: 'Status Pernikahan',
    type: 'radio',
    fullWidth: true,
    options: Object.keys(MaritalStatus).map((item) => {
      return { label: MaritalStatusMap[item as MaritalStatus], value: item, key: item };
    }),
    validation: {
      required: 'Status Pernikahan harus diisi'
    }
  },
  {
    name: 'entity.beneficial_owner.phone_number',
    label: 'Nomor Handphone',
    placeholder: '0000',
    type: 'phonenumber',
    validation: {
      required: 'Nomor Handphone harus diisi',
      validate: {
        isEmpty: (value) => !!value.slice(3) || 'Nomor Handphone harus diisi',
        isNumber: (value) => !isNaN(Number(value)) || 'Pastikan format nomor sesuai',
        isPositive: (value) => Number(value) > 0 || 'Pastikan format nomor sesuai'
      }
    }
  },
  {
    name: 'entity.beneficial_owner.citizenship',
    label: 'Kewarganegaraan',
    type: 'text',
    disabled: true
  },
  {
    name: 'Address',
    label: 'Alamat Sesuai KTP',
    type: 'group',
    children: [
      {
        name: 'entity.beneficial_owner.address.street_address',
        label: 'Alamat Jalan',
        placeholder: 'Alamat',
        type: 'text',
        span: 12,
        fullWidth: true,
        validation: {
          required: 'Alamat Jalan harus diisi'
        }
      },
      {
        name: 'entity.beneficial_owner.address.rt',
        label: 'RT',
        placeholder: 'RT',
        type: 'text',
        span: 2,
        fullWidth: true,
        validation: {
          required: 'RT harus diisi',
          validate: {
            isNumber: (value) => !isNaN(Number(value)) || 'Pastikan format RT sesuai',
            isPositive: (value) => Number(value) > 0 || 'Pastikan format RT sesuai'
          }
        }
      },
      {
        name: 'entity.beneficial_owner.address.rw',
        label: 'RW',
        placeholder: 'RW',
        type: 'text',
        span: 2,
        fullWidth: true,
        validation: {
          required: 'RW harus diisi',
          validate: {
            isNumber: (value) => !isNaN(Number(value)) || 'Pastikan format RW sesuai',
            isPositive: (value) => Number(value) > 0 || 'Pastikan format RW sesuai'
          }
        }
      },
      {
        name: 'entity.beneficial_owner.citizenship',
        label: 'Negara',
        type: 'text',
        span: 8,
        fullWidth: true,
        disabled: true
      },
      {
        name: 'entity.beneficial_owner.address.province',
        label: 'Provinsi',
        type: 'autocomplete',
        defaultValue: '',
        options: Object.keys(Province).map((item) => {
          return { label: ProvinceMap[item as Province], value: item, key: item };
        }),
        fullWidth: true,
        span: 8,
        validation: {
          required: 'Provinsi harus diisi'
        }
      },
      {
        name: 'entity.beneficial_owner.address.city',
        label: 'Kota',
        placeholder: 'Kota',
        defaultValue: '',
        type: 'autocomplete',
        options: Object.keys(Dati2).map((item) => {
          return { label: Dati2Map[item as Dati2], value: t(Dati2Map[item as Dati2]) as string, key: item };
        }),
        span: 4,
        fullWidth: true,
        validation: {
          required: 'Kota harus diisi'
        }
      },
      {
        name: 'entity.beneficial_owner.address.district',
        label: 'Kecamatan',
        placeholder: 'Kecamatan',
        type: 'text',
        span: 4,
        fullWidth: true,
        validation: {
          required: 'Kecamatan harus diisi'
        }
      },
      {
        name: 'entity.beneficial_owner.address.village',
        label: 'Kelurahan/Desa',
        placeholder: 'Kelurahan/Desa',
        type: 'text',
        span: 4,
        fullWidth: true,
        validation: {
          required: 'Kelurahan/Desa harus diisi'
        }
      },
      {
        name: 'entity.beneficial_owner.address.postal_code',
        label: 'Kode Pos',
        placeholder: 'Kode Pos',
        type: 'text',
        span: 4,
        fullWidth: true,
        validation: {
          required: 'Kode Pos harus diisi',
          validate: {
            minLength: (value) => value.length === 5 || 'Pastikan format kode pos sesuai, contoh : 10110',
            isNumber: (value) => !isNaN(Number(value)) || 'Pastikan format kode pos sesuai, contoh : 10110',
            isPositive: (value) => Number(value) > 0 || 'Pastikan format kode pos sesuai, contoh : 10110'
          }
        }
      }
    ]
  },
  {
    name: `beneficialOwnerDifferentAddress`,
    label: 'Alamat Domisili bila berbeda dari KTP?',
    type: 'radio',
    fullWidth: true,
    options: Object.keys(beneficialOwnerDifferentAddress).map((item) => {
      return { label: beneficialOwnerDifferentAddress[item as BeneficialOwnerAddressAnswer], value: item, key: item };
    }),
    validation: {
      required: 'Alamat Domisili bila berbeda dari KTP harus diisi'
    }
  },
  {
    conditional: {
      dependOn: 'beneficialOwnerDifferentAddress',
      value: BeneficialOwnerAddressAnswer.YES
    },
    name: 'Address',
    label: 'Alamat Domisili',
    type: 'group',
    children: [
      {
        name: 'entity.beneficial_owner.domicile_address.street_address',
        label: 'Alamat Jalan',
        placeholder: 'Alamat',
        type: 'text',
        span: 12,
        fullWidth: true
      },
      {
        name: 'entity.beneficial_owner.domicile_address.rt',
        label: 'RT',
        placeholder: 'RT',
        type: 'text',
        span: 2,
        fullWidth: true,
        validation: {
          required: false,
          validate: {
            isNumber: (value) => (value ? !isNaN(Number(value)) || 'Pastikan format RT sesuai' : true),
            isPositive: (value) => (value ? Number(value) > 0 || 'Pastikan format RT sesuai' : true)
          }
        }
      },
      {
        name: 'entity.beneficial_owner.domicile_address.rw',
        label: 'RW',
        placeholder: 'RW',
        type: 'text',
        span: 2,
        fullWidth: true,
        validation: {
          required: false,
          validate: {
            isNumber: (value) => (value ? !isNaN(Number(value)) || 'Pastikan format RW sesuai' : true),
            isPositive: (value) => (value ? Number(value) > 0 || 'Pastikan format RW sesuai' : true)
          }
        }
      },
      {
        name: 'entity.beneficial_owner.citizenship',
        label: 'Negara',
        type: 'text',
        span: 8,
        fullWidth: true,
        disabled: true
      },
      {
        name: 'entity.beneficial_owner.domicile_address.province',
        label: 'Provinsi',
        type: 'autocomplete',
        defaultValue: '',
        options: Object.keys(Province).map((item) => {
          return { label: ProvinceMap[item as Province], value: item, key: item };
        }),
        fullWidth: true,
        span: 8
      },
      {
        name: 'entity.beneficial_owner.domicile_address.city',
        label: 'Kota',
        placeholder: 'Kota',
        defaultValue: '',
        type: 'autocomplete',
        options: Object.keys(Dati2).map((item) => {
          return { label: Dati2Map[item as Dati2], value: t(Dati2Map[item as Dati2]) as string, key: item };
        }),
        span: 4,
        fullWidth: true
      },
      {
        name: 'entity.beneficial_owner.domicile_address.district',
        label: 'Kecamatan',
        placeholder: 'Kecamatan',
        type: 'text',
        span: 4,
        fullWidth: true
      },
      {
        name: 'entity.beneficial_owner.domicile_address.village',
        label: 'Kelurahan/Desa',
        placeholder: 'Kelurahan/Desa',
        type: 'text',
        span: 4,
        fullWidth: true
      },
      {
        name: 'entity.beneficial_owner.domicile_address.postal_code',
        label: 'Kode Pos',
        placeholder: 'Kode Pos',
        type: 'text',
        span: 4,
        fullWidth: true,
        validation: {
          required: false,
          validate: {
            minLength: (value) =>
              value ? value.length === 5 || 'Pastikan format kode pos sesuai, contoh : 10110' : true,
            isNumber: (value) =>
              value ? !isNaN(Number(value)) || 'Pastikan format kode pos sesuai, contoh : 10110' : true,
            isPositive: (value) =>
              value ? Number(value) > 0 || 'Pastikan format kode pos sesuai, contoh : 10110' : true
          }
        }
      }
    ]
  },
  {
    name: 'entity.beneficial_owner.npwp',
    label: 'Nomor NPWP',
    placeholder: '0000',
    type: 'text',
    validation: {
      required: 'Nomor NPWP harus diisi',
      validate: {
        isNumber: (value: string) => !isNaN(Number(value)) || 'Nomor NPWP harus berupa angka',
        minLength: (value: string) => value.length === 15 || 'Nomor NPWP harus terdiri dari 15 digit'
      }
    }
  },
  {
    name: 'entity.beneficial_owner.profession',
    label: 'Pekerjaan',
    placeholder: 'Pekerjaan',
    type: 'text',
    validation: {
      required: 'Pekerjaan harus diisi'
    }
  },
  {
    name: 'entity.beneficial_owner.income_source',
    label: 'Sumber Pendapatan',
    type: 'autocomplete',
    defaultValue: '',
    options: Object.keys(BeneficialOwnerIncomeSourceType).map((item) => {
      return { label: BeneficialOwnerIncomeSourceMap[item as BeneficialOwnerIncomeSourceType], value: item, key: item };
    }),
    validation: {
      required: 'Sumber Pendapatan harus diisi'
    }
  },
  {
    name: 'entity.beneficial_owner.monthly_income',
    label: 'Pendapatan Bulanan',
    placeholder: '0',
    type: 'currency',
    validation: {
      valueAsNumber: true,
      required: 'Pendapatan Bulanan harus diisi',
      validate: {
        isPositive: (value) => Number(value) > 0 || 'Pastikan format sesuai'
      }
    }
  },
  {
    name: 'entity.beneficial_owner.relationship',
    label: 'Hubungan dengan Perusahaan',
    placeholder: 'Hubungan',
    type: 'text',
    validation: {
      required: 'Hubungan dengan Perusahaan harus diisi'
    }
  },
  {
    name: 'entity.beneficial_owner.identity_document_id',
    type: 'file',
    label: 'Dokumen Identitas',
    validation: {
      required: 'Dokumen Identitas harus diisi'
    }
  },
  {
    name: 'entity.beneficial_owner.document_ids',
    type: 'file',
    allowMultiple: true,
    label: 'Dokumen Pendukung Hubungan Dengan Perusahaan',
    validation: {
      required: 'Dokumen Pendukung Hubungan Dengan Perusahaan harus diisi'
    }
  }
];
